// Shared data for holidays and leaves across the application

// Nigerian Public Holidays 2024-2026
export const publicHolidays = [
    // 2024
    { date: '2024-01-01', name: "New Year's Day" },
    { date: '2024-01-14', name: 'Makara Sankranti' },
    { date: '2024-01-26', name: 'Republic Day' },
    { date: '2024-03-29', name: 'Good Friday' },
    { date: '2024-04-01', name: 'Easter Monday' },
    { date: '2024-04-10', name: 'Eid-el-Fitr' },
    { date: '2024-04-11', name: 'Eid-el-Fitr Holiday' },
    { date: '2024-05-01', name: "Workers' Day" },
    { date: '2024-05-27', name: "Children's Day" },
    { date: '2024-06-12', name: 'Democracy Day' },
    { date: '2024-06-17', name: 'Eid-el-Kabir' },
    { date: '2024-06-18', name: 'Eid-el-Kabir Holiday' },
    { date: '2024-09-16', name: 'Eid-el-Maulud' },
    { date: '2024-10-01', name: 'Independence Day' },
    { date: '2024-12-25', name: 'Christmas Day' },
    { date: '2024-12-26', name: 'Boxing Day' },
    // 2025
    { date: '2025-01-01', name: "New Year's Day" },
    { date: '2025-03-30', name: 'Eid-el-Fitr' },
    { date: '2025-03-31', name: 'Eid-el-Fitr Holiday' },
    { date: '2025-04-18', name: 'Good Friday' },
    { date: '2025-04-21', name: 'Easter Monday' },
    { date: '2025-05-01', name: "Workers' Day" },
    { date: '2025-05-27', name: "Children's Day" },
    { date: '2025-06-06', name: 'Eid-el-Kabir' },
    { date: '2025-06-07', name: 'Eid-el-Kabir Holiday' },
    { date: '2025-06-12', name: 'Democracy Day' },
    { date: '2025-09-05', name: 'Eid-el-Maulud' },
    { date: '2025-10-01', name: 'Independence Day' },
    { date: '2025-12-25', name: 'Christmas Day' },
    { date: '2025-12-26', name: 'Boxing Day' },
    // 2026
    { date: '2026-01-01', name: "New Year's Day" },
    { date: '2026-03-20', name: 'Eid-el-Fitr' },
    { date: '2026-03-21', name: 'Eid-el-Fitr Holiday' },
    { date: '2026-04-03', name: 'Good Friday' },
    { date: '2026-04-06', name: 'Easter Monday' },
    { date: '2026-05-01', name: "Workers' Day" },
    { date: '2026-05-27', name: "Children's Day" },
    { date: '2026-05-27', name: 'Eid-el-Kabir' },
    { date: '2026-05-28', name: 'Eid-el-Kabir Holiday' },
    { date: '2026-06-12', name: 'Democracy Day' },
    { date: '2026-08-25', name: 'Eid-el-Maulud' },
    { date: '2026-10-01', name: 'Independence Day' },
    { date: '2026-12-25', name: 'Christmas Day' },
    { date: '2026-12-26', name: 'Boxing Day' },
]

// Leave types with balances (excluding sick leave - managed via Leave Management)
export const leaveTypes = [
    { value: 'annual', label: 'Annual Leave', balance: 26, color: 'text-org-blue-primary' },
    { value: 'compassionate', label: 'Compassionate Leave', balance: 5, color: 'text-purple-600' },
    { value: 'study', label: 'Study Leave', balance: 5, color: 'text-orange-600' },
    { value: 'lwp', label: 'Leave Without Pay', balance: 30, color: 'text-red-600' }
]

// Helper to get holiday by date string (YYYY-MM-DD)
export const getHolidayByDate = (dateStr) => {
    return publicHolidays.find(h => h.date === dateStr)
}

// Helper to check if a date falls within an approved leave period
export const getLeaveByDate = (dateStr, approvedLeaves, employeeId) => {
    return approvedLeaves.find(leave => {
        if (leave.status !== 'approved') return false
        if (leave.employeeId && leave.employeeId !== employeeId) return false
        const checkDate = new Date(dateStr)
        const startDate = new Date(leave.fromDate || leave.startDate)
        const endDate = new Date(leave.toDate || leave.endDate)
        return checkDate >= startDate && checkDate <= endDate
    })
}

// Get approved leaves from localStorage (synced with Leave management)
export const getApprovedLeaves = () => {
    const storedLeaves = localStorage.getItem('leaveRequests')
    if (storedLeaves) {
        const leaves = JSON.parse(storedLeaves)
        return leaves.filter(l => l.status === 'approved')
    }
    // Default approved leaves if nothing in localStorage
    return [
        { id: 1, employeeId: '53110546', fromDate: '2025-01-20', toDate: '2025-01-22', leaveType: 'annual', leaveTypeName: 'Annual Leave', status: 'approved' },
        { id: 2, employeeId: '53110546', fromDate: '2025-02-10', toDate: '2025-02-12', leaveType: 'sick', leaveTypeName: 'Sick Leave', status: 'approved' },
    ]
}

// Months array
export const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

// Get available years for timesheet (previous year, current, next year)
export const getAvailableYears = () => {
    const currentYear = new Date().getFullYear()
    return [currentYear - 1, currentYear, currentYear + 1]
}
